export var isSupportEncrypt = function () { return !!btoa && !!atob; };
export function encodeToBase64(content) {
    if (!isSupportEncrypt())
        return content;
    return btoa(encodeURI(content));
}
export function decodeWithBase64(base64) {
    if (!isSupportEncrypt())
        return base64;
    return decodeURI(atob(base64));
}
//# sourceMappingURL=encryption.js.map